
import React, {Component} from 'react';
import JobControlBoardTable from './JobControlBoardTable';
import {Button} from 'react-bootstrap';
import {Box} from 'reactjs-admin-lte'
import FontAwsome from 'react-fontawesome';
import IframeModal from '../../../component/element/IframeModal'
import WorkDocAttachmentDoc from '../WorkDocAttachmentDoc'
import {connect} from 'react-redux'
class WorkJobPhoto extends Component {

  constructor(...args){
    super(...args)
    this.state = {data:[],defaultOption:'claim'}
  }

  loadData(workData,workState){
    this.refs.jcbTable.getWrappedInstance().loadData([workData],workState)
    this.setState({data:workData},()=>{
      this.refs.wdAtt.getWrappedInstance().loadData(workData.work_no)
    })
  }

  onPrintClick() {
    let {defaultOption,data} = this.state
    let url = ''
    if (process.env.NODE_ENV == "development") {
      url  = './?startPage=PrintWorkJobPhoto&wo='+data.work_no+'&cat='+defaultOption
    } else {
      url = './pdf/v2?startPage=PrintWorkJobPhoto&wo='+data.work_no+'&cat='+defaultOption
    }
    this.refs.iframePrint.loadUrl(url)
  }

  onCatChange(cat){
    this.setState({defaultOption:cat})
  }

  render(){
    let {data} = this.state
    let {messages} = this.props
    return (
      <Box>
        <Box.Header  className='text-center'>
          <Box.Title>
                          
          </Box.Title> 
          <Box.Tools>
            <div className="text-right" style={{display:(this.props.showPrint==true?'':'none')}}>
              <Button className="btn bg-maroon" onClick={this.onPrintClick.bind(this)}>
                <FontAwsome name="print" />&nbsp;{messages['Print Image Report']}
              </Button>
            </div>
          </Box.Tools>
        </Box.Header>
        <Box.Body>
          <JobControlBoardTable ref='jcbTable' showSearch={false}/>
          <WorkDocAttachmentDoc
              ref='wdAtt'
              workNo={data.work_no}
              showPrint={false}
              onCatChange={this.onCatChange.bind(this)}
              loadFirst={false}
            >
            </WorkDocAttachmentDoc> 
          <IframeModal ref='iframePrint' title={messages['Print Document']} />
        </Box.Body>
      </Box>
    )
  }
}

WorkJobPhoto.defaultProps = {
  showPrint:false
}

export default WorkJobPhoto = connect(
  (state) => ({messages: state.message.view.workdoc.jobcontrol.WorkJobPhoto}),null,null,{withRef:true}
)(WorkJobPhoto);





// WEBPACK FOOTER //
// ./src/view/workdoc/jobcontrol/WorkJobPhoto.js